import React from "react";
import useProduct from "../../../../../../Hook/useProduct";
import { Link } from "react-router-dom";
import Rating from "@mui/material/Rating";
import Button from "@mui/material/Button";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const Spicy = () => {
  const { categories } = useProduct(
    `https://rocky-earth-23971.herokuapp.com/products?categories=${"spicy"}`
  );
  return (
    <div className="container my-5">
      <div className="row">
        <p className="text-muted my-3">
          মসলা ফুডে আয়েশ বিলুপ্তপ্রায় পণ্য যুক্ত করেছে। ফলে দামটাও একটা বেশী
          পড়বে। তবে ভোক্তাকে নির্ভেজাল আর নিরাপদ পণ্য দেয়ায় টাকার ষোল আনাই
          পুষিয়ে নিতে পারবেন। এ তালিকায় রাখা হয়েছে- *সরিষার তেল *তিলের তেল
          *তিসির তেল *সূর্যমুখীর তেল *নারকেল তেল *কাঁচা হলুদ-হলুদের গুড়া *আদা
          *মরিচ-গুড়ো মরিচ *চুই ঝাল। সবই পাওয়া যাবে আয়েশের উৎপাদিত পণ্য থেকে।
        </p>
      </div>
      <div className="row g-4">
        <hr />
        <p className="text-center display-6 text-muted">Spicy Products</p>
        <hr />
        {categories.map((data) => (
          <div className="col-sm-6 col-md-4 col-lg-3" key={data._id}>
            <div className="card h-100">
              <div className="card p-2  shadow">
                <img src={data.imageFile} alt="imageFile" height="200" />
              </div>
              <div className="p-3">
                <Link to="/">
                  <h5 className="text-capitalize mt-3">{data.productTitle}</h5>
                </Link>
                <div className="my-3">
                  <Rating name="read-only" value={3} readOnly />
                </div>
                <div className="d-flex justify-content-between">
                  <Button variant="contained">Add to cart</Button>
                  <Button variant="outlined">
                    <FavoriteBorderIcon />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Spicy;
